import { render } from "./GuruKosong.vue?vue&type=template&id=13cb75d2"
import script from "./GuruKosong.vue?vue&type=script&lang=js"
export * from "./GuruKosong.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__